import type { Networkish } from "@/types";
import React, { ReactNode } from "react";

import UiWidgetChainSelectorBadge from "@/components/Ui/Widget/ChainSelector/Chain";
import { SupCheckboxChecked, SupIconCheckbox, SupIconButton, SupText } from "@repo/core-ui";

interface UiWidgetChainSelectorMultiSelectProps {
  chainList: Networkish[];
  selectedChains: Networkish[];
  label?: string | ReactNode;
  onClick?: (chainId: Networkish) => void;
}
export default function UiWidgetChainSelectorMultiSelect({ label, chainList, selectedChains, onClick }: UiWidgetChainSelectorMultiSelectProps) {
  return (
    <div className="w-full space-y-2 p-2">
      {label !== undefined && <div className="my-2 flex h-3 w-full items-center">{typeof label === "string" ? <SupText variant="caption">{label}</SupText> : label}</div>}
      <div className="grid grid-cols-2 gap-y-2">
        {chainList.sort().map(chainId => (
          <div key={`multiselect-chain-${chainId}`} className="flex cursor-pointer space-x-2 hover:opacity-70" onClick={() => onClick?.(chainId)}>
            <SupIconButton active={selectedChains.includes(chainId)} activeIcon={<SupCheckboxChecked />}>
              <SupIconCheckbox />
            </SupIconButton>
            <UiWidgetChainSelectorBadge isSmall className="p-[0.5px]" chainId={chainId} />
          </div>
        ))}
      </div>
    </div>
  );
}
